import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setSuccessMsg("");
    try {
      const { data } = await axios.post(`${API}/newsletter/subscribe`, {
        email,
        name: name || undefined,
      });
      const msg = data.message || "Subscribed.";
      toast.success(msg);
      setSuccessMsg(msg);
      setEmail("");
      setName("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Try again.";
      toast.error(typeof msg === "string" ? msg : "Invalid email address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className={compact ? "space-y-5" : "space-y-7"}
    >
      {!compact && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <label className="overline block mb-3" htmlFor="ns-name">Your Name (optional)</label>
          <input
            id="ns-name"
            data-testid="newsletter-name-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="What do the stars call you?"
            className="input-line"
          />
        </motion.div>
      )}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
      >
        <label className="overline block mb-3" htmlFor="ns-email">Email Address</label>
        <input
          id="ns-email"
          data-testid="newsletter-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@somewhere.cosmos"
          className="input-line"
        />
      </motion.div>
      <motion.button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
      >
        {loading ? "Sending…" : "Join the Letter"}
      </motion.button>
      {successMsg && (
        <motion.p
          data-testid="newsletter-success"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-sm text-[#D4AF37] font-mono tracking-wide"
        >
          ✦ {successMsg}
        </motion.p>
      )}
    </form>
  );
}
